<template>
  <div class="guide-management" v-if="!fetching">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div v-if="false">
            <span> Version: {{ config.version }}v </span>
            <span class="ml-5"> Deploy Date: {{ config.build_date }} </span>
            <span class="ml-5">
              Firebase Info:
            </span>
          </div>
          <b-tabs
            v-if="permittedTabs.length > 0"
            defaultActiveKey="profile"
            content-class="mt-3"
            @activate-tab="handleActivateTab"
          >
            <b-tab
                pill
              :ref="aSection.id"
              v-for="(aSection, index) in permittedTabs"
              :key="index"
              :title="aSection.title"
            >
              <template #title>
                <h6><strong>
                  {{ aSection.title }}
                </strong></h6>
              </template>
              <component
                :is="aSection.component"
                v-bind="Object.assign({}, propsData)"
                :ref="aSection.componentName"
              >
              </component>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import config from "@/assets/_config.json";
import Users from "./users";
import Articles from "./articles";
import Connects from "./connects";
import Presents from "./presents";
import Publishings from "./publishings";
import Resources from "./resources";
import Sessions from "./sessions";
import Tools from "./tools";
import Tracks from "./tracks";
import Connections from "./connections";
import Forms from "./forms";
import BetaUsers from "./betaUsers";
import JourneyAssets from "./journeyAssets";
import Crew from "./crew";
import Bloggers from "./bloggers";
import GFormBlogSubmission from "./gFormBlogSubmissions";
import GFormBlogList from "./gFormBlogList";
import Companies from "./companies";
import Events from "./events";
import Faqs from "./faqs";
import Tags from "./tags";

import RSVPForms from "./rsvpForms";
import MemoriesForm from "./memoriesForms";
import FavesForm from "./faveForms";
import BlogForms from "./blogForms";
import firebase from "firebase";

export default {
  computed: {
    ...mapGetters({
      profile: "user/profile"
    }),
    propsData() {
      return {
        profile: this.profile
      };
    },
    permittedTabs() {
      //@TODO- Maybe make a Mixin
      if (
        this.profile &&
        this.profile._dashboards &&
        this.profile._dashboards.admin &&
        this.profile._dashboards.admin._account &&
        this.profile._dashboards.admin._account.type
      ) {
        return this.sections.filter(aSection => {
          return (
            Array.isArray(aSection.permissions) &&
            aSection.permissions.includes(
              this.profile._dashboards.admin._account.type
            ) &&
            aSection.isAvail
          );
        });
      } else {
        return [];
      }
    },
    accountType() {
      let type = "Free";
      if (
        this.profile._dashboards.guide._account &&
        this.profile._dashboards.guide._account.type == "starter"
      )
        type = "Starter";
      else if (
        this.profile._dashboards.guide._account &&
        this.profile._dashboards.guide._account.type == "premium"
      )
        type = "Premium";
      return type;
    },
    sectionsValid (){
      return this.sections && Array.isArray(this.sections) && this.sections.length > 0 ?
          this.sections.filter(aSection => {
                return aSection.isAvail === true }
            ) : [];
    }
  },
  beforeMount() {
    this.fetching = true;
  },
  mounted() {
    this.getProfile();
  },
  methods: {
    handleActivateTab(tabIdx) {
      let refName = this.sectionsValid[tabIdx].componentName;
      let theComponents = this.$refs[refName];
      if ( theComponents[0].hasOwnProperty("handleActivation")) {
        theComponents[0].handleActivation();
      }
    },
    getProfile() {
      this.$nprogress.start();
      this.$store
        .dispatch("user/getProfile")
        .then(() => {
          if (
            this.profile._dashboards &&
            this.profile._dashboards.blogger &&
            this.profile._dashboards.blogger.profileName
          ) {
            console.log(this.profile);
            this.fetching = false;
            this.showProfile = true;
          } else {
            this.fetching = false;
          }
          this.$nprogress.done();
        })
        .catch(error => {
          this.$nprogress.done();
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        });
    },
    copytoClipboard(link) {
      navigator.clipboard.writeText(link);
      this.popupText = "Copied!";
    },
    changePopupText() {
      setTimeout(() => {
        this.popupText = "Copy to clipboard";
      }, 300);
    },
    getNested({ obj, def }, ...args) {
      let truthy = args.reduce((obj, level) => obj && obj[level], obj);
      if (truthy) return truthy;
      else return def;
    },
    guideProcessCompleted() {
      this.showProfile = true;
    },
    trigerChooseVideo() {
      this.$el.querySelector("input[type='file']").click();
    },
    fileSelected(e) {
      try {
        if (e.target.files[0].name.length > 35) {
          this.filename = e.target.files[0].name.substring(0, 35) + "...";
        } else {
          this.filename = e.target.files[0].name;
        }
        console.log(e.target.files[0]);
        let func = firebase.functions().httpsCallable("uploadVideotoVimeo");
        func({
          path: "D:/MyJourneyBinder/public/resources/videos/CharityVideo.mp4"
        })
          .then(res => {
            console.log(res);
          })
          .catch(e => {
            console.log(e);
          });
      } catch (e) {
        console.log(e);
      }
    },
    updateBloggerInfo() {
      this.$store
        .dispatch("listings/updateBloggerInfo", this.profile)
        .then(res => {
          this.$store
            .dispatch("user/publishedBloggerInfo", this.profile)
            .then(res => {
              this.$store.dispatch("user/showNotification", {
                title: "Successfully Publised",
                description: "Users can see your changes now.",
                variant: "success"
              });
            });
        });
    }
  },
  data() {
    return {
      config,
      fetching: false,
      showProfile: false,
      filename: null,
      blogVideo: "blog-video",
      popupText: "Copy to clipboard",
      sections: [
        {
          title: "Users",
          id: "users",
          component: Users,
          componentName: "Users",
          permissions: ["super"],
          isAvail: true
        },
        {
          title: "Crew",
          id: "crew",
          component: Crew,
          componentName: "Crew",
          permissions: ["super"],
          isAvail: false
        },
        {
          title: "Publishings",
          id: "publishings",
          component: Publishings,
          componentName: "Publishings",
          permissions: ["super"],
          isAvail: false
        },
        {
          id: "sessions",
          title: "Sessions",
          component: Sessions,
          componentName: "Sessions",
          permissions: ["super"],
          isAvail: false
        },
        {
          id: "tracks",
          title: "Tracks",
          component: Tracks,
          componentName: "Tracks",
          permissions: ["super"],
          isAvail: false
        },
        {
          id: "bloggers",
          title: "Bloggers",
          component: Bloggers,
          componentName: "Bloggers",
          permissions: ["super", "blog"],
          isAvail: false
        },
        {
          id: "blog_submissions",
          title: "Blog Submissions",
          component: GFormBlogSubmission,
          componentName: "GFormBlogSubmission",
          permissions: ["super", "blog"],
          isAvail: false
        },
        {
          id: "blog_list",
          title: "Blog Article List",
          component: GFormBlogList,
          componentName: "GFormBlogList",
          permissions: ["super", "blog"],
          isAvail: false
        },
        {
          id: "articles",
          title: "Articles",
          component: Articles,
          componentName: "Articles",
          permissions: ["super", "blog"],
          isAvail: false
        },
        {
          id: "companies",
          title: "Companies",
          component: Companies,
          componentName: "Companies",
          permissions: ["super"],
          isAvail: false
        },
        {
          id: "events",
          title: "Events",
          component: Events,
          componentName: "Events",
          permissions: ["super"],
          isAvail: false
        },
        {
          id: "connects",
          title: "Connects",
          component: Connects,
          componentName: "Connects",
          permissions: ["super"],
          isAvail: false
        },
        {
          id: "tools",
          title: "MyApps",
          component: Tools,
          componentName: "Tools",
          permissions: ["super"],
          isAvail: false
        },
        {
          id: "resources",
          title: "Resources",
          component: Resources,
          componentName: "Resources",
          permissions: ["super"],
          isAvail: false
        },
        {
          id: "connections",
          title: "Connections",
          component: Connections,
          componentName: "Connections",
          permissions: ["super"],
          isAvail: false
        },
        {
          id: "presents",
          title: "Presents",
          component: Presents,
          componentName: "Presents",
          permissions: ["super"],
          isAvail: false
        },
        {
          id: "forms",
          title: "Forms",
          component: Forms,
          componentName: "Forms",
          permissions: ["super"],
          isAvail: false
        },
        {
          id: "journey_assets",
          title: "JourneyAssets",
          component: JourneyAssets,
          componentName: "JourneyAssets",
          permissions: ["super"],
          isAvail: false
        },
        {
          id: "beta_users",
          title: "Beta Users",
          component: BetaUsers,
          componentName: "BetaUsers",
          permissions: ["super"],
          isAvail: false
        },
        {
          id: "rsvp_forms",
          title: "RSVPS",
          component: RSVPForms,
          componentName: "RSVPForms",
          permissions: ["super","blog"],
          isAvail: true
        },
        {
          id: "memories_forms",
          title: "Memories (Submitted)",
          component: MemoriesForm,
          componentName: "MemoriesForm",
          permissions: ["super","blog"],
          isAvail: true
        },
        {
          id: "faves_form",
          title: "Faves ",
          component: FavesForm,
          componentName: "FavesForm",
          permissions: ["super","blog"],
          isAvail: true
        },
        {
          id: "blog_Forms",
          title: "Birthday Blogs ",
          component: BlogForms,
          componentName: "BlogForms",
          permissions: ["super","blog"],
          isAvail: true
        },
        {
          id: "tutorials",
          title: "Tutorials", //Pull from JSON
          component: Users,
          componentName: "Users",
          isAvail: true
        },
        {
          id: "tags",
          title: "Hotjar",
          component: Tags,
          componentName: "Tags",
          isAvail: true
        },
        {
          id: "tags",
          title: "Ads",
          component: Tags,
          componentName: "Tags",
          isAvail: true
        },
        {
          id: "tags",
          title: "Analytics",
          component: Tags,
          componentName: "Tags",
          isAvail: true
        },
        {
          id: "faqs",
          title: "FAQs",
          component: Faqs,
          componentName: "Faqs",
          isAvail: true
        }
      ]
    };
  },
};
</script>
<style lang="scss" scoped>
.tabs .nav-tabs {
  max-width: 100%;
}
.guide-management {
  padding: 24px;
  height: 100%;
  .profile-card {
    border-radius: 8px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    padding: 16px;
    .personel {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      img {
        height: 48px;
        width: 48px;
        border-radius: 50%;
        object-fit: cover;
      }
      .profile-name {
        margin-left: 10px;
        h3 {
          font-weight: 600;
          font-size: 16px;
          line-height: 22px;
          color: #474d52;
        }
        p {
          font-weight: normal;
          font-size: 14px;
          line-height: 19px;
          color: #8d99a0;
          margin: 0;
        }
      }
    }
    .desc {
      margin-top: 15px;
      p {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;

        /* Body */

        color: #474d52;
      }
    }
    .foot {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      & > div {
        margin-right: 12px;
        cursor: pointer;
      }
    }
  }
  .upload-video {
    cursor: pointer;
    margin-top: 27px;
    height: 150px;
    width: 100%;
    background-color: #f3f6f9;
    // border: 1px dashed #b3c2cb;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23DDDDDDFF' stroke-width='3' stroke-dasharray='3%2c 8' stroke-dashoffset='9' stroke-linecap='square'/%3e%3c/svg%3e");
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 8px;
    p {
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      margin: 0;
      color: #b3c2cb;
    }
    input {
      position: absolute;
    }
  }
  .published {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #474d52;
  }
  .btn-round-fill {
    margin-top: 18px;
  }
}
.heading__ {
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.05em;
  color: #8d99a0;
  text-transform: uppercase;
  margin-bottom: 0;
  margin-top: 10px;
}
.link__ {
  display: grid;
  grid-template-columns: 1fr 30px;
  align-items: center;
  .link {
    overflow-wrap: anywhere;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: var(--theme-color);
  }
  .ico {
    cursor: pointer;
    justify-self: flex-end;
  }
}
</style>
